module.exports = __webpack_public_path__ + "img/calling.ddf234e6.svg";